






import Vue from "vue"
import ResetRequestForm from "./ResetRequestForm.vue"
import SimplePage from "~/components/custom/layout/SimplePage.vue"

export default Vue.extend({
  components: {
    ResetRequestForm,
    SimplePage,
  },
})
